export const SET_IPD_PHARMACY_LIST = 'SET_IPD_PHARMACY_LIST';
export const PATCH_IPD_PHARMACY_ITEM = 'PATCH_IPD_PHARMACY_ITEM';
export const SET_AUTHORISED_DISPENSE = 'SET_AUTHORISED_DISPENSE';
